import { defineComponent, onMounted, inject, watch, ref } from 'vue';
//import { router } from '../../../../../modules/main/web_booking_consumer/routes';

import { Booking } from "../../services/booking"
import { Payment } from "../../services/payment";

import header_menu from "../header/menu.vue"
import footer_item from "../base/common/footer.vue"
import hero from "../header/hero.vue"

import basket from "../base/common/basket.vue"
import basket_minimal from "../base/common/basket_minimal.vue"
import basket_header from "../base/common/header.vue"

import booking_notes from "../base/4_checkout/booking_notes.vue"
import passengers from "../base/4_checkout/passengers.vue"
import trip_summary from "../base/4_checkout/summary.vue"
import payment_confirmation from "../base/4a_Payment/payment_confirmation.vue"
import payment_credit_card from "../base/4a_Payment/payment_credit_card.vue"
import payment_method from "../base/4a_Payment/payment_method.vue"
import payment_summary from "../base/4a_Payment/payment_summary.vue"

import { Web_Engine } from '../../services/web_engine';

import { response_booking } from "../../objects/v1_3/booking/search/response_booking";
import { response_booking_trip } from "../../objects/v1_3/booking/search/response_booking_trip";
import { response_booking_trip_passenger } from "../../objects/v1_3/booking/search/response_booking_trip_passenger";
import { currency } from "../../objects/v1_2/Currency/currency";
import { request_payment_initialise_internal } from "../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { response_login_payment } from "../../objects/agent/identity/v1_3/response_login_payment";

let Book: Booking = new Booking();
let Pay: Payment = new Payment();
let web_engine: Web_Engine = new Web_Engine();
const isValid : boolean = false;

export default defineComponent({
    components: {
        booking_notes,
        footer_item,
        header_menu,
        basket,
        basket_minimal,
        basket_header,
        trip_summary,
        passengers,
        payment_confirmation,
        payment_credit_card,
        payment_method,
        payment_summary,
        hero
    },
    data() {
        return {
            isValid,
            timedOut: false,
            user_currency: new currency as currency,
            param_booking_id: "",
            param_session_id: "",
            param_payment_app_id: "",
            param_provider_name: "",
            booking_id: ""
        }
    },
    methods: {
        toBookingId(booking_id_string: string) : string {
            if (booking_id_string) {
                const regex = /(?<=\-)(.+?)(?=\-)/g;
                const matches2 = booking_id_string.match(regex);
                return matches2 ? matches2[0] : "";
            }
            return "";
        },
        toProviderName(param_provider_method: string): string {
            let provider_name : string = "";

            if (param_provider_method != undefined && param_provider_method != "") {
                if (param_provider_method == 'cyb') {
                    provider_name = "cybersource";
                } else if (param_provider_method == 'stp') {
                    provider_name = "stripe";
                } else if (param_provider_method == 'tpg') {
                    provider_name = "ttc_payment_gateway";
                } else if (param_provider_method == 'bt') {
                    provider_name = "bank_transfer";
                } else {
                    //fallback
                    provider_name = import.meta.env.VITE_PAYMENT_METHOD;
                }
            }

            return provider_name;
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        async initView() {
            //if(this.$store.getters.get_Booking?.group_booking_id == undefined || this.$store.getters.get_Booking?.group_booking_id == 0 || this.$store.getters.get_Booking?.group_booking_id == null) {

                //see if we have a valid bookingid param (payment link)
                this.param_booking_id = this.$router.currentRoute.value.params.bookingid.toString() ?? "";
                this.booking_id = this.toBookingId(this.param_booking_id);
                this.param_session_id = this.$router.currentRoute.value.params.sessionid.toString() ?? "";

                //the wrong app_id is getting passed, it needs to be 8CF36C75-1A67-4E43-8982-1A6CF9C599EC not 89632732-f30e-4ca3-8afb-a323bd30e10a for AAT
                this.param_payment_app_id = import.meta.env.VITE_PAYMENT_APP_ID; //this.$router.currentRoute.value.params.appid || import.meta.env.VITE_PAYMENT_APP_ID;
                this.param_provider_name = this.toProviderName(this.$router.currentRoute.value.params.provider.toString()) ?? "";
                
                if (await this.has_Booking(this.toBookingId(this.param_booking_id), this.param_session_id)) {
                    this.isValid = true;
                };
                this.$store.commit("Set_Payment_APP_ID", { app_id: this.param_payment_app_id });
                //}
            return isValid;
        },
        async has_Booking(group_booking_id: string, session_id: string) {
            let booking_details : response_booking = await Book.Get_Booking_Session(this.$store, group_booking_id, session_id).then((response) => {
                return response;
            });

            let payment_session : request_payment_initialise_internal = await Pay.Get_Payment_Session(this.$store, session_id, this.param_provider_name, this.param_payment_app_id);
            payment_session.provider_name = this.param_provider_name;
            
            if (booking_details.trips != null && booking_details.trips.length > 0) {
                payment_session.get_booking.trips = booking_details.trips;
            } else {
                booking_details = payment_session.get_booking;
            }
            this.$store.commit('Payment_Session', { Payment_Session: payment_session });

            if (booking_details != null) {
                this.$store.commit("Set_Payment_Full_Payment", { Payment: payment_session.payment_initialise.full_payment });
                this.$store.commit("Set_Payment_Deposit", { Payment: payment_session.payment_initialise.deposit });
                this.$store.commit("Setup_Booking", { Booking_Details: booking_details });

                var selected_payment_method : response_login_payment = new response_login_payment();
                selected_payment_method.method = 'CC';
                selected_payment_method.nett_gross = (payment_session.payment_initialise.nett_sale == true) ? "N" : "G";
                selected_payment_method.description = 'CreditCard';
                selected_payment_method.provider = this.param_provider_name;
                this.$store.commit("Set_Payment_Selected", { Selected_Payment: selected_payment_method});
       
                var firstTripCurrency : string = payment_session.payment_initialise.iso_currency_code ?? "GBP";; // booking_details.trips[0].iso_currency_code ?? "GBP";
                this.user_currency.currency_info = await web_engine.Get_Currency_By_Country_Code(firstTripCurrency);
                this.$store.commit('Initialise_Currency', { Currency_Details:  this.user_currency });
                return true
            };
            return false;
        },        
        getHeroImage(): string {
            return String(import.meta.env.VITE_DEFAULT_HERO_IMAGE);
        },
        home_Click() {
            this.$router.push('/');
        },
        async startTimeOut() {
            await new Promise(resolve => setTimeout(resolve, 60000));
            this.timedOut = true
        },
        getContactInfo(): string {
            if (import.meta.env.VITE_DEFAULT_CONTACT_LOGIN_TEXT != undefined) {
                return String(import.meta.env.VITE_DEFAULT_CONTACT_LOGIN_TEXT);
            }
            else {
                return String(import.meta.env.VITE_DEFAULT_CONTACT_TEXT);
            }
        }
    },
    mounted() {
        this.initView();
        this.startTimeOut();
    }
});